<template lang="">
  <base-material-card
    color="primary"
    icon="mdi-finance"
    inline
    class="px-5 py-5"
  >
    <template v-slot:after-heading>
      <div class="display-1 font-weight-light">
        {{titulo}}
      </div>
    </template>
    <v-form class="pt-5">
      <v-row align="center" class="mx-auto">
        <v-col cols="12" class="py-0">
          <v-alert dense outlined type="warning" color="#FB8C00">
            <div>
              Ao contrato do indíce oficial, os <b>indíces estimados</b> são especificos para cada empresa e <b>"NÃO COMPARTILHADOS"</b>,
              ou seja, será necessário entrar em cada um dos sistemas hexa's e <b>importar essa informação de forma separada</b>.
            </div>
          </v-alert>
        </v-col>
      </v-row>
      <v-row align="center" class="mx-auto">
        <v-col cols="12" class="py-0">
          <v-alert dense outlined type="info" color="blue" class="pa-2">
            <a href="javascript:void(0)" @click="getArquivoModelo()">Clique aqui</a> para baixar o modelo para a importação.
            <br>OBS: O arquivo deve conter as seguintes colunas: <b>{{arquivo.cabecalhoEsperado.join(', ')}}</b> (exatamente nessa ordem e com esses nomes).
          </v-alert>
        </v-col>
      </v-row>
      <v-row align="center" class="mx-auto">
        <v-col cols="12" class="py-0">
          <validation-provider v-slot="{ errors }" rules="required">
            <v-file-input
              v-model="arquivo.fileObj"
              label="Arquivo CSV"
              placeholder="Selecione um arquivo CSV"
              accept=".csv, .zip"
              loader-height="4"
              truncate-length="30"
              outlined
              :loading="arquivo.uploading"
              :success="arquivo.id && arquivo.fileObj ? true : false"
              :error-messages="errors"
              @change="uploadNewFile(arquivo.fileObj)"
            />
          </validation-provider>
          <validation-provider rules="required">
            <input type="hidden" name="validate-upload-normas-tecnicas" :value="arquivo.id" />
          </validation-provider>
        </v-col>
      </v-row>
      <parametros-arquivo-csv 
        :delimitador.sync="arquivo.delimitador"
        :involucro.sync="arquivo.involucro"
        :escape.sync="arquivo.escape"
      />
    </v-form>
  </base-material-card>
</template>

<script>
import ArquivosService from "@/services/ArquivosService";
import AtualizacaoIndicesService from '@/services/AtualizacaoIndicesService';

export default {
  components: {
    ParametrosArquivoCsv: () => import("@/components/general/GeneralParametrosArquivoCsv.vue")
  },

  data: () => ({
    arquivo: {
      fileObj: undefined,
      id: "",
      delimitador: `;`,
      involucro: `"`,
      escape: `"`,
      uploading: false,
      cabecalhoEsperado: [
        'MES_REFERENCIA',
        'VARIACAO_MES'
      ]
    }
  }),

  computed:{
    titulo() {
      return this.$route.params.id ? 'Editar Indice IPCA Estimado' : 'Adicionar Índice IPCA Estimado';
    }
  },

  methods: {
    uploadNewFile(arquivo) {
      if (!arquivo) return;

      this.arquivo.id = "";
      this.arquivo.uploading = true;

      let formDataWithFile = new FormData();
      formDataWithFile.append("file", arquivo);

      ArquivosService.uploadFile(formDataWithFile)
        .then(async response => { 
          await this.validaHeader(
            response.data.arquivoId,
            this.arquivo.delimitador,
            this.arquivo.involucro,
            this.arquivo.escape,
            this.arquivo.cabecalhoEsperado
          );

          this.arquivo.id = response.data.arquivoId 
        })
        .catch(err => {
          if (err?.data?.error_code == 120 || err?.data?.error_code == 121) {
            this.$toast.error(err.data.erro, "", { position: "topRight", timeout: 6000 });
          } else {
            this.$toast.error("Erro no upload do arquivo.", "", { position: "topRight" });
            console.error("Erro ao fazer upload: ", err);
          }

          this.arquivo.fileObj = null;
        })
        .finally(() => this.arquivo.uploading = false);
    },

    validaHeader(arquivoId, delimitador, involucro, escape, cabecalhoEsperado) {
      return ArquivosService.validarHeaderCSV(arquivoId, { delimitador, involucro, escape, cabecalhoEsperado })
        .catch(err => { throw err });
    },

    getArquivoModelo() {
      this.$toast.info("Processando...", "", { position: "topRight", timeout: 1250 });
      
      AtualizacaoIndicesService.getArquivoModelo()
        .then(async res => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;

          link.setAttribute("download", `arquivo_modelo_indice_ipca_estimado.csv`);
          document.body.appendChild(link);
          link.click();
        })
        .catch(err => {
          this.$toast.error("Erro ao baixar arquivo padrão do sistema", "", { position: "topRight"});
          console.error(err);
        })
    },

    exportData() {
      return {
        arquivoId: this.arquivo.id,
        delimitador: this.arquivo.delimitador,
        involucro: this.arquivo.involucro,
        escape: this.arquivo.escape
      }
    }
  }
}
</script>